import React, { useState, useEffect } from 'react';

function LogBanner({ logMessage, setLogMessage, color }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (logMessage) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setLogMessage(''); // Clear the message after fading out
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [logMessage, setLogMessage]);

  return (
<div style={{ 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    width: '100%',
    top: 0,
    backgroundColor: color, 
    opacity: isVisible ? 1 : 0,
    height: isVisible ? '50px' : '0', // Set height to auto when visible, 0 when hidden 
    transition: 'opacity 2s, height 1s', // Include height in the transition with a duration of 2 seconds
    color: '#fff', // Text color setting
    fontSize: '15px', // Font size setting
    fontWeight: '700', // Font weight setting
    overflow: 'hidden' // Hide overflowing content
    }}>
    {logMessage}
    </div>

  );
}

export default LogBanner;
